import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* 3rd party React table component used to render out dataTable https://react-table.js.org/ */
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

const SeachResultsTable = styled(ReactTable)`
    .rt-th, rt-td {
        white-space: pre-wrap !important;
    }

    .rt-th, .rt-td:hover {
        cursor: pointer;
    }

    .rt-noData {
        font-size: 1.5em;
        width:100%;
        background: rgba(255,255,255,.9) !important;
        color: rgba(0,0,0,1) !important;
        padding:30px !important;
        text-align:center;
    }
`;

const TextLink = styled(Link)`
    font-size: 2rem;
    color: #333333;
`;

const PDFLink = styled.a`
    font-size: 2rem;
    color: #333333;
`;



//import the static asset URLs var from the config file
import * as RJRTConfigVars from '../../../config';

class ResultsTable extends Component {

    constructor(props) {
        super(props);
        this.handleRowClick = this.handleRowClick.bind(this);
    }

    //need to return false here to prevent the table component from sorting the data
    //we do this through another call to Azure Search
    handleSort() {
        return false;
    }

    handleRowClick(rowInfo, event) {

        //there are links to files within each row..so if we click on a link, follow that link instead of
        //launching the modal
        if (event.target.href) {
            return;
        }

        this.props.rowClickHandler(rowInfo);
    }    

    render() {

        const {
            pages,
            fetchDataHandler,
            resultData,
            formBrand,
            formType,
            pageSize,
            defaultPageSize,
        } = this.props;


        return (
            <SeachResultsTable
            pages={pages}
            onFetchData={fetchDataHandler}
            manual
            showPaginationTop
            showPageSizeOptions={false} 
            resizable={false} 
            defaultPageSize={pageSize} 
            loading={false}
            showPageJump={false}                  
            minRows={0}
            multiSort={false}
            noDataText='No documents found'
            pageSize={defaultPageSize}
            onSortedChange={this.handleSort.bind(this)}  
            data={resultData}           

            getTdProps={(state, rowInfo, column, instance) => {
                return {
                    onClick: (e) => this.handleRowClick(rowInfo, e)
                };
                }}

            
            columns={[
            {
                Header: "Title",
                accessor: d => d.TITLE,
                id: 'TITLE',
                minWidth:300
            },
            {
                Header: "Document ID",
                accessor: d => `${d.DOCUMENT_BEGIN}-${d.DOCUMENT_END}`,
                id: 'DOCUMENT_BEGIN'
            },
            {
                Header: "Document Date",
                accessor: d => d.DOCUMENT_DATE,
                id: 'DOCUMENT_DATE',
                show: formType !== 'courtaction',
            },
            {
                Header: "Date of Ruling",
                accessor: d => d.DATE_OF_RULING,
                id: 'DATE_OF_RULING',
                show: formType === 'courtaction',
            },  
            {
                Header: "Author",
                accessor: d => d.AUTHOR,
                id: 'AUTHOR',
                sortable: formBrand !== 'lorillard',
                show: formBrand !== 'lorillard',
            },
            {
                Header: "Addressee",
                accessor: d => d.ADDRESSEE,
                id: 'ADDRESSEE',
                minWidth: 200,
                sortable: formBrand !== 'lorillard',
                show: formBrand !== 'lorillard',
            },
            {
                Header: "Person Author",
                accessor: d => d.PERSON_AUTHOR,
                id: 'PERSON_AUTHOR'
            },
            {
                Header: "Person Addressee",
                accessor: d => d.PERSON_ADDRESSEE,
                id: 'PERSON_ADDRESSEE'
            },
            {
                Header: "Organization Author",
                accessor: d => d.ORGANIZATION_AUTHOR,
                id: 'ORGANIZATION_AUTHOR'
            },
            {
                Header: "Organization Addressee",
                accessor: d => d.ORGANIZATION_ADDRESSEE,
                id: 'ORGANIZATION_ADDRESSEE'
            },
            {
                Header: "Text",
                accessor: d => <TextLink target="_blank" to={`/${d.COLLECTION.toLowerCase()}/public/fileData/${d.ACC}`}><FontAwesomeIcon icon={faFileAlt} /></TextLink>,
                id: 'viewText',
                style:{textAlign:'center'},
                width:50,
                show: (formType === 'public' || formType === 'courtaction' || formType === 'allResults') ? true : false
            },
            {
                Header: "PDF",
                accessor: d => <PDFLink href={`${RJRTConfigVars.RJRTStaticAssetURLs[d.COLLECTION.toLowerCase()]['public']}${d.FILE_FULLNAME}`}><FontAwesomeIcon icon={faFilePdf} /></PDFLink>,
                id: 'downloadPDF',
                style:{textAlign:'center'},
                width:80,
                show: (formType === 'public' || formType === 'courtaction' || formType === 'allResults') ? true : false
            }
        ]
        } />
        );
    }
}

ResultsTable.propTypes={
    pages: PropTypes.number,
    fetchDataHandler: PropTypes.func,
    rowClickHandler: PropTypes.func,
    resultData: PropTypes.arrayOf(PropTypes.object),
    formBrand: PropTypes.string,
    formType: PropTypes.string,
    pageSize: PropTypes.number,
    defaultPageSize: PropTypes.number,
}


export default ResultsTable;


// WEBPACK FOOTER //
// ./src/components/searchResults/components/resultsTable.js